<script>
  import { onMount, onDestroy } from "svelte";
  import { ignore } from "./tools.js";
  import {External} from "../external";

  export let value = 0,
    min = 0,
    max = 100,
    step = 1,
    suffix = "px",
    label = "",
    description = "",
    clz = "mt-15",
    showValue = true,
    sameLine = false,
    onChange = ignore;

  let input, ui;

  onMount(function () {
    min = parseInt(min);
    max = parseInt(max);
    step = parseFloat(step);
    value = parseFloat(value || min || 0);

    input = External.$(input);
    ui = External.$(ui);
    External.Tools.addSlider({
      min: min,
      max: max,
      step: step,
      value: value,
      updatedViewSuffix: suffix,
      element: ui,
      onChange: function (val) {
        value = val;
        onChange(val);
      }
    });
  });
</script>

<div class:input-slider-wrapper={sameLine} class="popup-input-wrapper {clz}">
  <h5 class="inline">{label}</h5>
  {#if description}
    <span>{description}</span>
  {/if}
  {#if showValue && !sameLine}
    <input type="text" readonly="readonly" class="slider-val" bind:this={input} />
  {/if}
  <div bind:this={ui}></div>
  {#if showValue && sameLine}
    <input type="text" readonly="readonly" class="slider-val" bind:this={input} />
  {/if}
</div>
